import React, { useContext, useState } from 'react';
import { addWatcher, removeWatcher } from '../../api/actionMemoApi';
import ConfigContext from '../../contexts/ConfigContext';
import { sendToast, formatAmDisplayString } from '../../utils/displayUtils';

interface FavoriteButtonProps {
    initialFav: boolean;
    id: number;
    amNumber: number;
    supNumber: number;
    setResponseError: Function;
    button: (watching: boolean, onClick: () => void) => JSX.Element;
    refresh?: Function;
}

const FavoriteButton = (props: FavoriteButtonProps) => {
    const [isFav, setIsFav] = useState(props.initialFav);
    const config = useContext(ConfigContext);

    const { id, amNumber, supNumber, setResponseError, refresh } = props;

    const toggleWatching = async () => {
        try {
            if (isFav) {
                await removeWatcher(config, id);
                sendToast(
                    <>
                        Unfavorited Action Memo:{' '}
                        <strong>{formatAmDisplayString(amNumber, supNumber)}</strong>{' '}
                    </>,
                );
            } else {
                await addWatcher(config, id);
                sendToast(
                    <>
                        Favorited Action Memo:{' '}
                        <strong>{formatAmDisplayString(amNumber, supNumber)}</strong>
                    </>,
                );
            }
            if (refresh) {
                refresh();
            }
        } catch (e) {
            if (e instanceof Error) {
                setResponseError(`Process favorites failed:  ${e.message}`);
            }
        }
    };

    const onClick = () => {
        toggleWatching();
        setIsFav(!isFav);
    };

    return props.button(isFav, onClick);
};

export default FavoriteButton;
